import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import {
    OrderModificationType,
} from 'app/enums/label.enums'
import requests from 'app/requests/Order/OrderPositioningSetup.requests'
import simpleApi from 'app/services/simpleApi'
import {
    PositioningSetupType,
} from '../orderConfirmation.types'

type RequestParams = {
    modificationType: OrderModificationType,
    orderNumber: string,
    data: PositioningSetupType,
}

const useUpdatePositioningSetup = (onSuccess: () => void) => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessUpdate,
        onError,
    } = useHandleStatusRequest({
        id: 'ModifyOrderStep',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            modificationType,
            orderNumber,
            data,
        }: RequestParams) => {
            return simpleApi({
                ...requests.updatePositioningSetup({
                    orderNumber,
                    data,
                    modificationType,
                }),
                token,
            })
        },
        onSuccess: onSuccessUpdate,
        onError,
    })
}

export default useUpdatePositioningSetup
